module.exports = __webpack_public_path__ + "static/img/icon-insurance-03.c1605cf5.png";